import { type HTMLAttributes, forwardRef } from 'react'
import { cardFrameVariants } from './CardFrame.variants'

export interface CardFrameProps extends HTMLAttributes<HTMLDivElement> {
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const CardFrame = forwardRef<HTMLDivElement, CardFrameProps>(
  ({ className, children, accentColor = 'none', ...props }, ref) => {
    return (
      <div className={cardFrameVariants({ accentColor, className })} ref={ref} {...props}>
        {children}
      </div>
    )
  }
)

CardFrame.displayName = 'CardFrame'
